import { useTranslation } from 'react-i18next';
import './HotelSalesHeader.css'
import HotelSalesDemo from './HotelSalesDemo';

function HotelSalesHeader() {
    const { t } = useTranslation();

    return (
        <div className='hotelsales-header' style={{ backgroundImage: 'url(/images/homepage-header.png' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip'>
                        {t('Hotel Sales Software')}
                    </div>
                    <h1 className='mt-3'>{t('Sales Software for Hotels: Your Complete Guide to Boosting Revenue in 2025')}</h1>
                    <p className='body-large'>
                        {t('Prostay hotel sales software helps you win more group bookings, automate proposals, and close deals faster. \n' +
                            'With built-in CRM, PMS integration, Guest and Agent Management, and AI follow-ups, it’s the smarter way to boost revenue in 2025. \n')}
                    </p>
                </div>
                <div className='col d-flex justify-content-end'>
                    <HotelSalesDemo title={t('Book a demo with your next hotel sales software')} />
                </div>
            </div>
        </div>
    )
}
export default HotelSalesHeader;